/**
 * @generated SignedSource<<1a8ad585eb527b46ac63b653433cb181>>
 * @relayHash eb35f46ea806b83c8ddf28d2fe4cdc60
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1157bf58f3cafdf01c9daab08bd15bf571831013ebbaf642927860c412b336b6

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ServiceDeskPortalSettingsQuery$variables = {
  cloudId: string;
};
export type ServiceDeskPortalSettingsQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CustomerPortalSettingsPage">;
};
export type ServiceDeskPortalSettingsQuery = {
  response: ServiceDeskPortalSettingsQuery$data;
  variables: ServiceDeskPortalSettingsQuery$variables;
};
({
  "__relay_internal__pv__atlassianjirarelayprovidersrcjsmportalrovoagentconfigexperiencerelayprovider": rovoAgentConfigExperienceFG_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcextractrovoagentconfigurationpackagerelayprovider": extractRovoAgentConfigurationPackageFG_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcextractrovoagentconfigurationpackagerelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjsmportalrovoagentconfigexperiencerelayprovider: {
    readonly get: () => boolean;
  };
});

import extractRovoAgentConfigurationPackageFG_provider from '@atlassian/jira-relay-provider/src/extract-rovo-agent-configuration-package.relayprovider';
import rovoAgentConfigExperienceFG_provider from '@atlassian/jira-relay-provider/src/jsm-portal-rovo-agent-config-experience.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v2 = [
  (v1/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 30
  },
  {
    "kind": "Literal",
    "name": "input",
    "value": {
      "onlyEditableAgents": true
    }
  }
],
v3 = [
  {
    "args": (v2/*: any*/),
    "concreteType": "AgentStudioAgentsConnection",
    "kind": "LinkedField",
    "name": "agentStudio_getAgents",
    "plural": false,
    "selections": [
      {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "hasNextPage"
          },
          {
            "kind": "ScalarField",
            "name": "endCursor"
          }
        ]
      },
      {
        "concreteType": "AgentStudioAgentEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "concreteType": "AgentStudioAssistant",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "id"
              },
              {
                "kind": "ScalarField",
                "name": "name"
              },
              {
                "kind": "ScalarField",
                "name": "externalConfigReference"
              },
              {
                "kind": "ScalarField",
                "name": "identityAccountId"
              },
              {
                "kind": "ScalarField",
                "name": "creatorType"
              },
              {
                "kind": "ScalarField",
                "name": "__typename"
              }
            ]
          },
          {
            "kind": "ScalarField",
            "name": "cursor"
          }
        ]
      }
    ]
  },
  {
    "args": (v2/*: any*/),
    "filters": [
      "cloudId",
      "input"
    ],
    "handle": "connection",
    "key": "RovoAgent_agentStudio_getAgents",
    "kind": "LinkedHandle",
    "name": "agentStudio_getAgents"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ServiceDeskPortalSettingsQuery",
    "selections": [
      {
        "args": [
          (v1/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "CustomerPortalSettingsPage"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmportalrovoagentconfigexperiencerelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcextractrovoagentconfigurationpackagerelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "ServiceDeskPortalSettingsQuery",
    "selections": [
      {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmportalrovoagentconfigexperiencerelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": (v3/*: any*/)
      },
      {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcextractrovoagentconfigurationpackagerelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": (v3/*: any*/)
      }
    ]
  },
  "params": {
    "id": "1157bf58f3cafdf01c9daab08bd15bf571831013ebbaf642927860c412b336b6",
    "metadata": {},
    "name": "ServiceDeskPortalSettingsQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjsmportalrovoagentconfigexperiencerelayprovider": rovoAgentConfigExperienceFG_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcextractrovoagentconfigurationpackagerelayprovider": extractRovoAgentConfigurationPackageFG_provider
    }
  }
};
})();

(node as any).hash = "c5f5439b89a531ccf42b97aa657752b9";

export default node;
